(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1338],{

/***/ 11454:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/categories/[category]",
      function () {
        return __webpack_require__(31174);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 31174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3204);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80220);
/* harmony import */ var _hiredigital_ui_LoadingArea__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84585);
/* harmony import */ var _components_Blog_Nav__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4911);
/* harmony import */ var _components_Blog_LatestPost__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8969);
/* harmony import */ var _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93651);
/* harmony import */ var _helpers_posts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36414);
/* harmony import */ var _helpers_error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85219);














var BlogStories = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 6545).then(__webpack_require__.bind(__webpack_require__, 86545));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86545)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_hiredigital_ui_LoadingArea__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            height: 500
        });
    },
    ssr: false
});
var Subscribe = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9669), __webpack_require__.e(8815), __webpack_require__.e(7628), __webpack_require__.e(7969)]).then(__webpack_require__.bind(__webpack_require__, 37969));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37969)
            ];
        }
    },
    ssr: false
});
var Blog = function(param) {
    var postData = param.postData, metaData = param.metaData, params = param.params;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(postData), posts = ref1[0], setPosts = ref1[1];
    var latestPost = postData === null || postData === void 0 ? void 0 : (ref = postData[0]) === null || ref === void 0 ? void 0 : ref.node;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), meta = ref2[0], setMeta = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var head = {
        title: "Insights | Hire Digital"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setPosts([]);
        setMeta({});
        setPosts(function() {
            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(postData);
        });
        setMeta(function() {
            return metaData;
        });
    }, [
        postData
    ]);
    var addMore = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data, newMeta, newPosts;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return (0,_helpers_posts__WEBPACK_IMPORTED_MODULE_9__/* .getStoriesByCategory */ .vd)(meta.endCursor, params.category);
                    case 3:
                        data = _ctx.sent;
                        setLoading(false);
                        newMeta = data === null || data === void 0 ? void 0 : data.pageInfo;
                        newPosts = data === null || data === void 0 ? void 0 : data.edges;
                        setPosts(function() {
                            return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(posts).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(newPosts));
                        });
                        setMeta(function() {
                            return newMeta;
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        pageHead: head,
        variant: _components_Layout_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Variants.INSIGHTS */ .Z.Variants.INSIGHTS,
        showHeaderBackground: true,
        hasHero: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Blog_Nav__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            latestPost ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Blog_LatestPost__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                latestPost: latestPost
            }) : "",
            (posts === null || posts === void 0 ? void 0 : posts.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlogStories, {
                posts: posts,
                hasNext: meta === null || meta === void 0 ? void 0 : meta.hasNextPage,
                isLoading: loading,
                onLoadMore: addMore,
                start: 1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Subscribe, {})
        ]
    });
};
Blog.propTypes = {
    postData: (prop_types__WEBPACK_IMPORTED_MODULE_13___default().array),
    metaData: (prop_types__WEBPACK_IMPORTED_MODULE_13___default().object),
    params: (prop_types__WEBPACK_IMPORTED_MODULE_13___default().object)
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_helpers_error__WEBPACK_IMPORTED_MODULE_10__/* .withError */ .A)(Blog));


/***/ }),

/***/ 85219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ withError; }
/* harmony export */ });
/* unused harmony export withGetServerSideError */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85034);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35230);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24246);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);





// import Error from 'next/error';
var PageNotFound = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6151), __webpack_require__.e(3651), __webpack_require__.e(8626), __webpack_require__.e(8643)]).then(__webpack_require__.bind(__webpack_require__, 58643));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58643)
            ];
        }
    }
});
var withGetServerSideError = function(getServerSideFn) {
    return function() {
        var _wrappedGetServerSideProps = _async_to_generator(regeneratorRuntime.mark(function _callee(ctx) {
            var result, error;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getServerSideFn(ctx);
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", result);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        ctx.res.statusCode = 404;
                        ;
                        error = {
                            statusCode: _ctx.t0.statusCode || 404,
                            message: _ctx.t0.message
                        };
                        return _ctx.abrupt("return", {
                            props: {
                                error: error
                            }
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        function wrappedGetServerSideProps(ctx) {
            return _wrappedGetServerSideProps.apply(this, arguments);
        }
        return wrappedGetServerSideProps;
    }();
};
// eslint-disable-next-line
var withError = function(Page) {
    return function WrappedPage(props) {
        var error = props.error;
        if (error) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PageNotFound, {});
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Page, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [856,6151,8579,3651,6414,3200,9774,2888,179], function() { return __webpack_exec__(11454); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);